/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Platforms_LabelInputs */

const en_common_header_explore_platforms_label = /** @type {(inputs: Common_Header_Explore_Platforms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

const zh_common_header_explore_platforms_label = /** @type {(inputs: Common_Header_Explore_Platforms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台`)
};

/**
* | output |
* | --- |
* | "Platforms" |
*
* @param {Common_Header_Explore_Platforms_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_platforms_label = /** @type {((inputs?: Common_Header_Explore_Platforms_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Platforms_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_platforms_label(inputs)
	return zh_common_header_explore_platforms_label(inputs)
});
export { common_header_explore_platforms_label as "common.header.explore.platforms.label" }